// extracted by mini-css-extract-plugin
module.exports = {"timerWithLabelsContainer":"CountdownTimer_timerWithLabelsContainer__3SsGY","timerValue":"CountdownTimer_timerValue__32Lxt","separator":"CountdownTimer_separator__3BNsd"};